import { api } from '@/services/index'
import store from '@/store'

const loadVendaRapidaNFCe = (_filter) => {
    store.dispatch('setVendaRapidaNFCeLoadingData', true)


    api.post(`/emsweb/listaVendaNFCe`, _filter)
        .then(_res => {
            store.dispatch('setVendaRapidaNFCeData', _res.data)

            setTimeout(function () {
                store.dispatch('setVendaRapidaNFCeLoadingData', false)
            }, 200)
        })
        .catch(_err => {            
            store.dispatch('setVendaRapidaNFCeSnackBar', {
                visible: true,
                message: `${_err.response.data.message}`
            })
        })
}

const loadVendaRapidaNFCeDetail = (_cliCodigo, _filter) => {
    store.dispatch('setVendaRapidaNFCeLoadingDataDetail', true)


    api.post(`/emsweb/listaVendaNFCeDetail/${_cliCodigo}`, _filter)
        .then(_res => {
            store.dispatch('setVendaRapidaNFCeDataDetail', _res.data)

            setTimeout(function () {
                store.dispatch('setVendaRapidaNFCeLoadingDataDetail', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setVendaRapidaNFCeSnackBar', {
                visible: true,
                message: `Ocorreu um erro. ${_err.response.data.message}`
            })
        })
}

const loadVendaRapidaNFCeSituations = (_filter) => {
    store.dispatch('setVendaRapidaNFCeLoadingSituations', true)

    api.post('/emsWeb/listaVendaNFCeSituacao', _filter)
        .then(_res => {
            store.dispatch('setVendaRapidaNFCeSituations', _res.data)
            setTimeout(function () {
                store.dispatch('setVendaRapidaNFCeLoadingSituations', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setNFCeSnackBar', {
                visible: true,
                message: `Ocorreu um erro. ${_err.response.data.message}`
            })
            store.dispatch('setVendaRapidaNFCeLoadingSituations', false)
        })
}

const loadVendaRapidaNFCeRejections = (_filter) => {
    store.dispatch('setVendaRapidaNFCeLoadingRejections', true)

    api.post('/emsweb/listaVendaNFCeRejeicao', _filter)
        .then(_res => {
            store.dispatch('setVendaRapidaNFCeRejections', _res.data)
            setTimeout(function () {
                store.dispatch('setVendaRapidaNFCeLoadingRejections', false)
            }, 200)
        })
        .catch(_err => {
            store.dispatch('setNFCeSnackBar', {
                visible: true,
                message: `Ocorreu um erro. ${_err.response.data.message}`
            })
            store.dispatch('setVendaRapidaNFCeLoadingRejections', false)
        })
}

export { loadVendaRapidaNFCe, loadVendaRapidaNFCeDetail, loadVendaRapidaNFCeSituations, loadVendaRapidaNFCeRejections }